import { render, staticRenderFns } from "./OverviewRoute.vue?vue&type=template&id=55a52488&scoped=true&"
import script from "./OverviewRoute.vue?vue&type=script&lang=js&"
export * from "./OverviewRoute.vue?vue&type=script&lang=js&"
import style0 from "./OverviewRoute.vue?vue&type=style&index=0&id=55a52488&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../.yarn/$$virtual/vue-loader-virtual-add9cc88d1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a52488",
  null
  
)

export default component.exports